import whiteCheckmark from '../../../images/components/scheduling/perfect-allocation.svg';
import greenCheckmark from '../../../images/components/scheduling/green-checkmark.svg';
import connectedProjectIconBlack from '../../../images/sections/scheduling-canvas/project-group-icon.svg';
import connectedProjectIconWhite from '../../../images/sections/scheduling-canvas/project-group-icon-white.svg';
import milestoneIconBlack from '../../../images/sections/scheduling-canvas/milestone-icon.svg';
import milestoneIconWhite from '../../../images/sections/scheduling-canvas/milestone-icon-white.svg';
import projectTeamIconBlack from '../../../images/sections/scheduling-canvas/project-team-icon.svg';
import projectTeamIconWhite from '../../../images/sections/scheduling-canvas/project-team-icon-white.svg';
import goToNextIconWhite from '../../../images/components/scheduling/go-to-next-white.svg';
import goToNextIcon from '../../../images/components/scheduling/go-to-next.svg';
import goToPreviousIcon from '../../../images/components/scheduling/go-to-previous.svg';
import goToPreviousIconWhite from '../../../images/components/scheduling/go-to-previous-white.svg';
import unassignedHeatmapPerson from '../../../images/components/scheduling/person.svg';
import highPriorityFlagWhite from '../../../images/cross-section-icons/high-priority-white.svg';
import dependencyHandleLeft from '../../../images/sections/scheduling-canvas/dependency-handle-left.svg';
import dependencyHandleRight from '../../../images/sections/scheduling-canvas/dependency-handle-right.svg';
import warningIconRed from '../../../images/sections/scheduling-canvas/warning-icon-red.svg';
import hexagonPlusGreen from '../../../images/components/scheduling/hexaplus.svg';
import bug from '../../../images/v2/components/workflow-task/bugs-icon-white.svg';
import blocked from '../../../images/cross-section-icons/blocked-white-icon.svg';
import warning from '../../../images/components/scheduling/warning-icon.svg';
import greenCheckmarkV2 from '../../../images/components/scheduling/green-checkmark-v2.svg';
import freeDayPattern from '../../../images/diagonal-lines-pattern.svg';
import expand from '../../../images/components/scheduling/expand.svg';
import collapse from '../../../images/components/scheduling/collapse.svg';
import expandAll from '../../../images/components/scheduling/expand-all.svg';
import collapseAll from '../../../images/components/scheduling/collapse-all.svg';
import {COMMON_IMAGE} from './canvas_timeline_util';

//mapId should be the same for all elements of the same type (ex: Project Groups), it is used to narrow down the search and avoid looping through a huge map every time
//for example for groups, we use group type

//cacheId should be different for every specific element you need cached
//for example if a group looks different when it is expanded than when it is not you will need two separate ids that store two different things
class CacheManager {
	constructor() {
		this.cache = new Map();
		this.commonMapId = 'canvas-timeline-cache-manager-common-map-id';
		this.cacheCommonImages();
	}

	cacheCommonImages() {
		const imageMap = {
			WHITE_CHECKMARK: whiteCheckmark,
			GREEN_CHECKMARK: greenCheckmark,
			GREEN_CHECKMARK_V2: greenCheckmarkV2,
			CONNECTED_PROJECT_BLACK: connectedProjectIconBlack,
			CONNECTED_PROJECT_WHITE: connectedProjectIconWhite,
			MILESTONE_ICON_BLACK: milestoneIconBlack,
			MILESTONE_ICON_WHITE: milestoneIconWhite,
			PROJECT_TEAM_ICON_BLACK: projectTeamIconBlack,
			PROJECT_TEAM_ICON_WHITE: projectTeamIconWhite,
			GO_TO_NEXT_WHITE: goToNextIconWhite,
			GO_TO_NEXT: goToNextIcon,
			GO_TO_PREVIOUS_WHITE: goToPreviousIconWhite,
			GO_TO_PREVIOUS: goToPreviousIcon,
			UNASSIGNED_HEATMAP_PERSON: unassignedHeatmapPerson,
			HIGH_PRIORITY_FLAG_WHITE: highPriorityFlagWhite,
			DEPENDENCY_HANDLE_LEFT: dependencyHandleLeft,
			DEPENDENCY_HANDLE_RIGHT: dependencyHandleRight,
			WARNING_ICON_RED: warningIconRed,
			HEXAGON_PLUS_GREEN: hexagonPlusGreen,
			BUG: bug,
			BLOCKED: blocked,
			WARNING: warning,
			FREEDAY: freeDayPattern,
			EXPAND: expand,
			COLLAPSE: collapse,
			EXPAND_ALL: expandAll,
			COLLAPSE_ALL: collapseAll,
		};
		for (const name in COMMON_IMAGE) {
			if (Object.prototype.hasOwnProperty.call(COMMON_IMAGE, name)) {
				const image = new Image();
				image.onload = () => {
					this.set(this.commonMapId, COMMON_IMAGE[name], image);
				};
				image.src = imageMap[name];
			}
		}
	}

	set(mapId, cacheId, data) {
		let map = this.cache.get(mapId);
		if (!map) {
			map = new Map();
			map.set(cacheId, data);
			this.cache.set(mapId, map);
		} else {
			map.set(cacheId, data);
		}
	}

	get(mapId, cacheId) {
		const map = this.cache.get(mapId);
		if (!map) return null;
		return map.get(cacheId) || null;
	}

	getCommonImage(cacheId) {
		return this.get(this.commonMapId, cacheId);
	}

	/* Safari cannot create patterns from svgs, so draw in the SVG to an adapter canvas
	 *  This can be replaced with getCommonImage once (if) this bug (from 2010) is resolved https://bugs.webkit.org/show_bug.cgi?id=45277 */
	getCommonImageSafariWorkaround(cacheId) {
		const map = this.cache.get(this.commonMapId);
		const adaptedImageCacheId = cacheId + 'adapter';
		if (!map.get(adaptedImageCacheId)) {
			const patternImage = this.getCommonImage(cacheId);
			const svgCanvas = document.createElement('canvas');
			svgCanvas.width = patternImage.width;
			svgCanvas.height = patternImage.height;
			const svgCtx = svgCanvas.getContext('2d');
			svgCtx.drawImage(patternImage, 0, 0, patternImage.width, patternImage.height);
			map.set(adaptedImageCacheId, svgCanvas);
		}
		return map.get(adaptedImageCacheId);
	}

	clear() {
		for (const key of this.cache.keys()) {
			if (key === this.commonMapId) continue;
			this.cache.delete(key);
		}
	}
}

export const cacheManager = new CacheManager();
